import React from 'react';
type Bubble = {
  type: 'text';
  from: 'them' | 'me';
  text: string;
  reaction?: string;
} | {
  type: 'voice';
  from: 'them' | 'me';
  duration: string;
};
type Screenshot = {
  bubbles: Bubble[];
};
export function TestimonialsSection() {
  const screenshots: Screenshot[] = [{
    bubbles: [{
      type: 'text',
      from: 'them',
      text: 'Compré el plan y bajé los 5 kilos que había subido. Entrenando con vos hace dos años tuve el mejor cuerpo de mi vida, me sentía sana y dejé por motivos personales, el peor error de mi vida!!!! Nunca más, son 30 minutos nada más, no lo hacía por autosaboteo'
    }]
  }, {
    bubbles: [{
      type: 'text',
      from: 'them',
      text: 'Hola! Perdón la hora, hoy termine la semana 4 del reto y nunca pensé qué tan rápido ya iba a ver los cambios. Me siento liviana, seguí la alimentación también y los cambios son INCREÍBLESSSS! Ansiedad por seguir nunca pensé decir esto ajjajajaj',
      reaction: '🥺'
    }]
  }, {
    bubbles: [{
      type: 'text',
      from: 'them',
      text: 'una pregunta antes de comprar… los videos son fáciles de seguir? soy re negada para entrenar sola en casa 🙈'
    }, {
      type: 'text',
      from: 'me',
      text: 'Holaa! Si re fáciles, son videos demostrativos paso a paso. Vas viendo cómo se hace cada ejercicio + modificaciones por si te cuesta alguno 🤍'
    }, {
      type: 'text',
      from: 'them',
      text: 'genia gracias!! lo compro ya 🙌'
    }]
  }, {
    bubbles: [{
      type: 'voice',
      from: 'them',
      duration: '0:47'
    }, {
      type: 'text',
      from: 'them',
      text: 'te mandé un audio porque no me alcanzaban las palabras jajaja pero básicamente me cambiaste la vida 🫶'
    }, {
      type: 'text',
      from: 'me',
      text: 'ya te lo escuchooo 🥺💕'
    }]
  }, {
    bubbles: [{
      type: 'text',
      from: 'them',
      text: 'Lo compré con muchas dudas porque ya había comprado otros programas que no me sirvieron. Y este es OTRA COSA. Los videos paso a paso hacen todo facilísimo, la alimentación es simple, los bonos son una locura. Si están dudando, háganlo 😍'
    }]
  }];
  return <section className="py-12 md:py-16 bg-cream-50 relative overflow-hidden" data-id="element-207">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-208">
        <div className="text-center mb-12" data-id="element-209">
          <div className="inline-block bg-brand-pink-600 text-white px-4 py-2 rounded-full text-xs font-bold uppercase tracking-wide mb-4" data-id="element-210">
            +2.000 MUJERES YA EMPEZARON
          </div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-gray-900 mb-4" data-id="element-211">
            ⭐ MENSAJES REALES QUE NOS LLEGAN
          </h2>
          <p className="text-gray-700 text-lg max-w-2xl mx-auto" data-id="element-212">
            Capturas de los DM que nos mandan las chicas que ya están haciendo
            el programa.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-10" data-id="element-213">
          {screenshots.map((screenshot, i) => <ChatScreenshot key={i} screenshot={screenshot} rotate={[-1.5, 1.2, -1, 1.8, -1.8, 1, -1.2, 1.5, -1][i % 9]} data-id="element-214" />)}
        </div>
      </div>
    </section>;
}
function ChatScreenshot({
  screenshot,
  rotate
}: {
  screenshot: Screenshot;
  rotate: number;
}) {
  return <div className="bg-white rounded-xl shadow-[0_18px_40px_-15px_rgba(0,0,0,0.25)] border border-gray-200/80 px-4 py-5 space-y-2" style={{
    transform: `rotate(${rotate}deg)`,
    fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "SF Pro", "Helvetica Neue", "Helvetica", "Segoe UI", Arial, sans-serif'
  }} data-id="element-215">
      {screenshot.bubbles.map((bubble, idx) => {
      const isMe = bubble.from === 'me';
      const prev = screenshot.bubbles[idx - 1];
      const isFirstInGroup = !prev || prev.from !== bubble.from;
      // Tight grouping
      const marginTop = idx === 0 ? '' : isFirstInGroup ? 'mt-3' : 'mt-1';
      if (bubble.type === 'voice') {
        return <div key={idx} className={`flex ${isMe ? 'justify-end' : 'justify-start'} ${marginTop}`} data-id="element-216">
              <div className={`flex items-center gap-2.5 pl-2 pr-3.5 py-1.5 max-w-[85%] rounded-[24px] ${isMe ? 'bg-gradient-to-tr from-purple-600 via-pink-500 to-pink-500 text-white' : 'bg-gray-100 text-gray-900'}`} data-id="element-217">
                <button className={`flex items-center justify-center w-8 h-8 rounded-full ${isMe ? 'bg-white/25' : 'bg-white'}`} aria-label="Reproducir audio" data-id="element-218">
                  <svg viewBox="0 0 24 24" className={`w-3.5 h-3.5 ${isMe ? 'fill-white' : 'fill-gray-700'}`} data-id="element-219">
                    <path d="M8 5v14l11-7z" data-id="element-220" />
                  </svg>
                </button>
                <div className="flex items-center gap-[2px] h-5" data-id="element-221">
                  {[5, 9, 13, 7, 11, 15, 9, 5, 11, 13, 7, 9, 5, 11, 7].map((h, k) => <span key={k} className={`w-[2px] rounded-full ${isMe ? 'bg-white/85' : 'bg-gray-500'}`} style={{
                height: `${h}px`
              }} data-id="element-222" />)}
                </div>
                <span className={`text-[12px] font-medium tabular-nums ${isMe ? 'text-white/90' : 'text-gray-500'}`} data-id="element-223">
                  {bubble.duration}
                </span>
              </div>
            </div>;
      }
      return <div key={idx} className={`flex ${isMe ? 'justify-end' : 'justify-start'} ${marginTop} ${bubble.reaction ? 'mb-3' : ''}`} data-id="element-224">
            <div className="relative max-w-[92%]" data-id="element-225">
              <div className={`px-4 py-2.5 text-[15px] leading-[1.4] tracking-[-0.01em] whitespace-pre-wrap ${isMe ? 'bg-gradient-to-tr from-purple-600 via-pink-500 to-pink-500 text-white rounded-[22px] rounded-br-md' : 'bg-gray-100 text-gray-900 rounded-[22px] rounded-bl-md'}`} data-id="element-226">
                {bubble.text}
              </div>

              {bubble.reaction && <div className={`absolute -bottom-3 ${isMe ? 'right-3' : 'left-3'} bg-white rounded-full pl-1.5 pr-2 py-[2px] text-[12px] shadow-[0_2px_6px_rgba(0,0,0,0.15)] border border-gray-100 flex items-center gap-0.5`} data-id="element-227">
                  <span data-id="element-228">{bubble.reaction}</span>
                </div>}
            </div>
          </div>;
    })}
    </div>;
}